import { Row, Col } from "antd";
import { Prop1side } from "./prop1Side";
import { Proposal1 } from "./proposal1";
function PropLayout1() {
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col md={6}>
          <div
            className="text-center"
            style={{ marginBottom: "25px", marginTop: "25px" }}
          >
            <img className="imgh" src="../../images/logo.png" alt="Logo" />
          </div>
          <Prop1side />
        </Col>
        <Col md={18}>
          <Proposal1 />
        </Col>
      </Row>
    </div>
  );
}

export { PropLayout1 };
